export default __webpack_public_path__ + "static/media/ninjacrafts-logo.c32c52ab.png";